<template>
  <div>
    <d-card-header class="border-bottom flex-header">
      <h6 class="m-0">Wezwania do zapłaty</h6>
      <div class="button-date-wrapper" >
        <d-button
          style="width: 100%; margin-top: -1px;"
          theme="success"
          :disabled="scheduleFinished">
          <span style="white-space: nowrap;">
            <i class="material-icons">add</i> Dodaj wezwanie
          </span>
        </d-button>
        <ss-date
          v-if="!scheduleFinished"
          @picked="isSendReminderVisible = true"
          type="text"
          name="reminder-date"
          v-model="reminderDate"
          placeholder=""/>
      </div>
    </d-card-header>

    <d-alert
      v-if="scheduleFinished"
      show
      theme="warning"
      class="my-4">
      Po zamknięciu umowy nie ma możliwości dodawania wezwań
    </d-alert>

    <d-list-group>
      <d-list-group-item>
        <d-form-row>
          <d-col
            v-if="!!schedule.include_vat"
            md="6"
            class="form-group">
            <div class="contract-info">
              <dl>
                <dt class="d-flex">
                  <label class="my-auto">Koszty monitów (netto)</label>
                </dt>
                <dd class="my-auto">
                  <ss-price-input
                    type="text"
                    name="default_reminder_price_net"
                    v-model="default_reminder_price_net"
                    @input="setGrossForValue(default_reminder_price_net, 'schedule.default_reminder_price', 'default_reminder_price')"
                    :class="{'is-invalid' : lar_errors.has('default_reminder_price_net')}"
                    placeholder=""
                    :disabled="isCalculatingNet"/>
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('default_reminder_price_net')">
                  </div>
                </dd>
              </dl>
            </div>
          </d-col>
          <d-col
            md="6"
            class="form-group">
            <div class="contract-info">
              <dl>
                <dt class="d-flex">
                  <label class="my-auto">Koszty monitów <span v-if="!!schedule.include_vat"> (brutto)</span></label>
                </dt>
                <dd class="my-auto">
                  <ss-price-input
                    type="text"
                    name="default_reminder_price"
                    :value="schedule.default_reminder_price"
                    placeholder=""
                    :disabled="!!schedule.include_vat"
                    :class="{'is-invalid' : lar_errors.has('default_reminder_price')}"/>
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('default_reminder_price')">
                  </div>
                </dd>
              </dl>
            </div>
          </d-col>
        </d-form-row>
      </d-list-group-item>
    </d-list-group>

    <div class="card card-small">
      <div class="card-body p-0 pb-3 text-center">
        <table class="table mb-0 responsive-table">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0">Numer wezwania</th>
              <th scope="col" class="border-0">Data wezwania</th>
              <th scope="col" class="border-0">
                Kwota z tytułu wystawienia
                <template v-if="!!scheduleProp.include_vat">
                  (brutto)
                </template>
              </th>
              <th scope="col" class="border-0">Kwota wpłacona</th>
              <th scope="col" class="border-0">Data wpłaty</th>
              <th scope="col" class="border-0 action-cell">Akcje</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(reminder, index) in reminders"
              :key="reminder.id"
              :class="{ 'green': getIsRowThemeSuccess(reminder) }">
              <td>
                <dt>Numer wezwania</dt>
                <dd>
                  {{ reminder.reminder_number }}<br />
                    <div
                        v-if="!reminder.is_paid"
                        class="button-date-wrapper">
                        <d-button
                            class="mt-1"
                            theme="primary"
                            :disabled="actionInProgress"
                            :class="{isLoading: downloading_id === index}"
                            @click.prevent="showSettlementPopup(reminder)">
                            Oznacz jako opłacone
                        </d-button>
                    </div>
                    <span
                      v-if="reminder.is_paid === 1"
                      class="badge badge-success mt-1 pb-2">
                      <i class="material-icons">euro</i> Opłacone
                    </span>
                </dd>
              </td>
              <td>
                <dt>Data wezwania</dt>
                <dd>
                  {{ reminder.reminder_date }}
                </dd>
              </td>
              <td>
                <dt>
                  Kwota z tytułu wystawienia
                  <template v-if="!!scheduleProp.include_vat">
                    (brutto)
                  </template>
                </dt>
                <dd>
                  {{ toNumber(reminder.penalty_amount) }} zł
                </dd>
              </td>
              <td>
                <dt>Kwota wpłacona</dt>
                <dd :class="{ 'text-success' : reminder.penalty_amount === reminder.amount_paid }">
                  {{ toNumber(reminder.amount_paid) }} zł
                </dd>
              </td>
              <td>
                <dt>Data wpłaty</dt>
                <dd>
                  {{ reminder.paid_date ? reminder.paid_date : '-' }}
                </dd>
              </td>
              <td>
                <dt>Akcje</dt>
                <dd>
                  <d-button
                    theme="primary"
                    class="mr-3"
                    :disabled="actionInProgress"
                    :class="{isLoading: downloading_id === index}"
                    @click.prevent="exportToPdf(reminder, index)">
                    <i class="material-icons">save_alt</i> Pobierz
                  </d-button>
                  <d-button
                    v-if="!scheduleFinished"
                    theme="danger"
                    :disabled="actionInProgress"
                    @click.prevent="removeReminder(reminder.id)">
                    Usuń
                  </d-button>
                </dd>
              </td>
            </tr>
            <tr v-if="!reminders.length">
              <td
                colspan="6"
                class="text-info text-center">
                Brak przypomnień do wyświetlenia.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <send-reminder-modal
      :default-reminder-price="scheduleProp.default_reminder_price"
      :default-reminder-price-net="default_reminder_price_net || 0"
      :is-modal-visible="isSendReminderVisible"
      :reminder-date="reminderDate"
      :schedule-id="scheduleProp.id"
      :isIncludeVat="!!scheduleProp.include_vat" />

    <settle-reminder-payment-modal
      v-if="!!reminderToSettle"
      :is-modal-visible="isSettlePaymentModalVisible"
      :reminder="reminderToSettle" />
  </div>
</template>

<script>
import ListUtils from '@/utils/ListUtils.js';
import CommonUtils from '@/utils/CommonUtils';
import FormUtils from '@/utils/FormUtils';
import LarErrors from '@/helpers/Errors';
import FileSaver from 'file-saver';
import SsDate from '@/components/common/SsDate';
import SsPriceInput from '@/components/common/SsPriceInput';
import SendReminderModal from '@/components/client/contract-partials/payment-requests/SendReminderModal.vue';
import SettleReminderPaymentModal from '@/components/client/contract-partials/payment-requests/SettleReminderPaymentModal.vue';

export default {
  name: 'ContractPaymentRequests',
  components: {
    SsDate,
    SsPriceInput,
    SendReminderModal,
    SettleReminderPaymentModal
  },
  props: {
    reminders: {
      default: () => [],
      type: Array
    },
    scheduleFinished: {
      required: true,
      type: Boolean
    },
    scheduleProp: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      actionInProgress: false,
      downloading_id: false,
      isSendReminderVisible: false,
      isSettlePaymentModalVisible: false,
      lar_errors: LarErrors,
      reminderDate: null,
      reminderToSettle: null,
      schedule: {},
      default_reminder_price_net: 0,
      isCalculatingNet: false
    }
  },
  mounted () {
    this.$bus.$on('send-reminder-modal-close', this.closeSendReminderModal);
    this.$bus.$on('settle-payment-modal-close', this.closeSettlePaymentModal);
    this.schedule = this.scheduleProp;

    this.setNetForValue(this.schedule.default_reminder_price, 'default_reminder_price_net', 'default_reminder_price_net');
  },
  methods: {
    removeReminder (remiderId) {
      this.actionInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/api/contract-reminders/remove-reminder',
        id: remiderId,
        idFiledName: 'reminder_id',
        successTitle: 'Wezwanie zostało usunięte',
        successText: '',
        confirmTitle: 'Uwaga',
        confirmText: 'Czy potwierdzasz usunięcie wezwania?',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie wezwania nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.actionInProgress = false;
          this.$bus.$emit('contract-reload-reminders');
          this.$bus.$emit('reload-contract');
        },
        cancelAction: () => {
          this.actionInProgress = false;
        },
      });
    },
    exportToPdf (reminder, index) {
      this.downloading_id = index;
      axios.post('api/contract-reminders/download-reminder-pdf ',
        {
          reminder_id: reminder.id
        },
        { responseType: 'blob' }).then(response => {
        let blob = new File(
          [response.data],
          reminder.payment_date + '_wezwanie_do_zaplaty.pdf',
          { type: 'application/pdf' }
        );
        FileSaver.saveAs(blob);
        this.downloading_id = '';
      }).catch(error => {
        this.downloading_id = '';
      })
    },
    closeSendReminderModal (shouldReload = true) {
      this.isSendReminderVisible = false;

      if (shouldReload) {
        this.$bus.$emit('reload-contract');
      }
    },
    getIsRowThemeSuccess (reminder) {
      return reminder.paid_date && reminder.paid_date.length > 0
    },
    toNumber (number) {
      return Vue.toNumber(number);
    },
    showSettlementPopup (reminder) {
      this.reminderToSettle = reminder;

      this.$nextTick(() => {
        this.isSettlePaymentModalVisible = true;
      })
    },
    closeSettlePaymentModal (shouldReload = true) {
      this.isSettlePaymentModalVisible = false;
      this.reminderToSettle = null;

      if (shouldReload) {
        this.$bus.$emit('reload-contract');
      }
    },
    async setGrossForValue (value, fieldPath, errorFieldName) {
      if (this.isCalculatingNet) {
        return;
      }

      if (!value) {
        this.lar_errors.clear(errorFieldName);
        CommonUtils.setValueInPath(this, fieldPath, 0);
        return;
      }

      let { value: grossValue, isError} = await FormUtils.getGrossValue(value);

      if (errorFieldName) {
        if (isError) {
          this.lar_errors.errors[errorFieldName] = ['Błąd obliczenia wartości'];
          CommonUtils.setValueInPath(this, fieldPath, 0);
          return;
        } else {
          this.lar_errors.clear(errorFieldName);
        }
      }

      CommonUtils.setValueInPath(this, fieldPath, grossValue);
    },
    async setNetForValue (value, fieldPath, errorFieldName) {
      Vue.set(this, 'isCalculatingNet', true);

      if (!value) {
        this.lar_errors.clear(errorFieldName);
        CommonUtils.setValueInPath(this, fieldPath, 0);
        return;
      }

      let { value: netValue, isError} = await FormUtils.getNetValue(value);
      if (errorFieldName) {
        if (isError) {
          this.lar_errors.errors[errorFieldName] = ['Błąd obliczenia wartości'];
          CommonUtils.setValueInPath(this, fieldPath, 0);
          await this.$nextTick()
          Vue.set(this, 'isCalculatingNet', false);
          return;
        } else {
          this.lar_errors.clear(errorFieldName);
        }
      }

      CommonUtils.setValueInPath(this, fieldPath, netValue);

      await this.$nextTick()
      Vue.set(this, 'isCalculatingNet', false);
    }
  },
  beforeDestroy () {
    this.$bus.$off('send-reminder-modal-close', this.closeSendReminderModal);
    this.$bus.$off('settle-payment-modal-close', this.closeSettlePaymentModal);
  }
}
</script>
